import {
    FETCH_HOME_DETAILS_BEGIN,
    FETCH_HOME_DETAILS_SUCCESS,
    FETCH_HOME_DETAILS_FAILURE
} from '../constants/homeActionTypes';
import { HomeService } from '../services/home.services';
import { config } from '../env_config/react-config';

export const fetchHomeDetailsRequest = () => ({
    type: FETCH_HOME_DETAILS_BEGIN
});

export const fetchHomeDetailsSuccess = result => ({
    type: FETCH_HOME_DETAILS_SUCCESS,
    payload: result
});

export const fetchHomeDetailsFailure = (error) => ({
    type: FETCH_HOME_DETAILS_FAILURE,
    payload: error
});

export const fetchHomeDetails = (retailerId) => dispatch => {
    if (retailerId) {
        dispatch(fetchHomeDetailsRequest());
        if(navigator.onLine){
            HomeService(retailerId).then(result => {
                if (result && result.length) {
                    localStorage.setItem(config.countryCode+'HomeService'+retailerId, JSON.stringify(result[0]));
                    dispatch(fetchHomeDetailsSuccess(result[0]));
                } else if(result && (result.error === 404 || result.length === 0)){
                    dispatch(fetchHomeDetailsFailure("Service Error"));
                }
            }).catch(error => {
                dispatch(fetchHomeDetailsFailure(error));
            });
        } else {
            const result = localStorage.getItem(config.countryCode+'HomeService'+retailerId);
            if(result === null){
                dispatch(fetchHomeDetailsFailure('offline'));
            } else {
                dispatch(fetchHomeDetailsSuccess(JSON.parse(result)));
            }
        }
    }
}
